import React, { useState } from "react";
import dayjs from "dayjs";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const STATUS_STYLE = {
  APPROVED: "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/20",
  REJECTED: "text-red-400 bg-red-500/10 border-red-500/20",
  PENDING:  "text-yellow-400 bg-yellow-500/10 border-yellow-500/20",
};

function slaUrgency(slaDueAt) {
  if (!slaDueAt) return null;
  const hours = dayjs(slaDueAt).diff(dayjs(), "hour");
  if (hours < 0)  return { label: "SLA Breached", style: "text-red-400 bg-red-500/10 border-red-500/20" };
  if (hours <= 4) return { label: `${hours}h left`,  style: "text-red-400 bg-red-500/10 border-red-500/20" };
  if (hours <= 24)return { label: `${hours}h left`,  style: "text-yellow-400 bg-yellow-500/10 border-yellow-500/20" };
  return null;
}

export default function RegularisationQueue({ loading, items, onApprove, onReject }) {
  const [comments, setComments] = useState({});
  const setComment = (id, val) => setComments(c => ({ ...c, [id]: val }));

  const pending = (items || []).filter(x => x.status === "PENDING" || !x.status);
  const decided = (items || []).filter(x => x.status && x.status !== "PENDING");

  if (loading) return (
    <div className={`${card} p-5`}>
      <div className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium mb-4">Regularisation Queue</div>
      <div className="space-y-2">{[1,2,3].map(i => <div key={i} className="h-16 rounded-lg bg-white/5 animate-pulse" />)}</div>
    </div>
  );

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Regularisation Queue</span>
        {pending.length > 0 && (
          <span className="text-xs text-yellow-400 bg-yellow-500/10 border border-yellow-500/20 px-2 py-0.5 rounded-full">
            {pending.length} pending
          </span>
        )}
      </div>

      <div className="p-4 space-y-2 max-h-96 overflow-y-auto">
        {items?.length === 0 ? (
          <p className="text-white/20 text-sm italic text-center py-4">No pending requests.</p>
        ) : (
          [...pending, ...decided].map(x => {
            const sla     = slaUrgency(x.slaDueAt);
            const decided = x.status && x.status !== "PENDING";
            const statusStyle = STATUS_STYLE[x.status] || STATUS_STYLE.PENDING;

            return (
              <div key={x.id} className="rounded-xl border border-[#00ff90]/15 bg-[#0d0d0d] p-4">
                <div className="flex items-start justify-between gap-3 flex-wrap">
                  <div className="min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-1">
                      <span className="text-xs font-mono text-white/30">{x.id}</span>
                      <span className="text-sm text-white/70 font-medium">{x.reason}</span>
                      {sla && (
                        <span className={`text-xs px-2 py-0.5 rounded-full border ${sla.style}`}>{sla.label}</span>
                      )}
                    </div>
                    <p className="text-xs text-white/30">
                      {x.employeeId} · {x.dept} · {x.date}
                      {x.submittedAt && ` · Submitted ${x.submittedAt.replace("T", " ").slice(0, 16)}`}
                    </p>
                  </div>

                  {decided ? (
                    <span className={`text-xs px-2 py-0.5 rounded-full border shrink-0 ${statusStyle}`}>{x.status}</span>
                  ) : (
                    <div className="flex items-center gap-2 flex-wrap shrink-0">
                      <input
                        placeholder="Comment…"
                        value={comments[x.id] || ""}
                        onChange={e => setComment(x.id, e.target.value)}
                        className="bg-black border border-white/10 rounded-lg px-3 py-1.5 text-xs text-white outline-none w-32 focus:border-[#00ff90]/30 transition-colors"
                      />
                      <button onClick={() => onApprove?.(x.id, comments[x.id] || "")}
                        className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/25 bg-[#00ff90]/8 text-[#00ff90]/70 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
                        Approve
                      </button>
                      <button onClick={() => onReject?.(x.id, comments[x.id] || "")}
                        className="text-xs px-3 py-1.5 rounded-lg border border-red-500/25 bg-red-500/8 text-red-400/70 hover:bg-red-500/15 hover:text-red-400 transition-colors">
                        Reject
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}